const requestHelper = () => {
    let _startSpinner = () => { };
    let _endSpinner = () => { };
    return {
        async run(fn) {
            try {
                _startSpinner();
                return await fn();
            }
            finally {
                _endSpinner();
            }
        },
        setStartSpinner(startSpinner) {
            _startSpinner = startSpinner;
        },
        setEndSpinner(endSpinner) {
            _endSpinner = endSpinner;
        },
    };
};
export default requestHelper();
